module.exports = __webpack_public_path__ + "img/lixeira.7868a67b.svg";